'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'dumpster';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f793';
var svgPathData = 'M34.9 64l506.2 0 2.6 12.9 32 160 3.8 19.1-37.4 0-28 224-32.2 0 4-32-395.8 0 4 32-32.2 0-28-224-37.4 0 3.8-19.1 32-160 2.6-12.9zM66.1 256l20 160 403.8 0 20-160-443.8 0zM514.9 96l-72.6 0 19.5 128 78.7 0-25.6-128zm-105 0l-105.9 0 0 128 125.4 0-19.5-128zM272 96l-106.2 0-19.2 128 125.4 0 0-128zM133.4 96l-72.3 0-25.6 128 78.7 0 19.2-128z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDumpster = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;